export default {
  hello: 'hello'
};
